import { defineMessages } from 'react-intl';

export default defineMessages({
  amplWarning:
    '{asset} is an asset affected by rebasing. Visit the {link1} or {link2} to learn more.',
  documentation: 'documentation',
  amplFaq: "Ampleforth's FAQ",
});
